import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { REDIRECT_MAP, canonicalUrl } from "@/lib/canonical";

// Only these production hosts are indexable. Everything else (preview/staging,
// redirecting hosts) and all /admin routes are noindex,nofollow.
const INDEXABLE_HOSTS = ["azekaglobal.com", "azekahealth.com"];

function upsertMetaRobots(content) {
  let el = document.head.querySelector('meta[name="robots"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", "robots");
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function IndexingControl() {
  const { pathname } = useLocation();
  useEffect(() => {
    const host = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";

    // Fallback redirect to the correct canonical domain, preserving path + query + hash.
    // The authoritative permanent (301) redirects are configured at the edge/registrar.
    const target = REDIRECT_MAP[host];
    if (target) {
      window.location.replace(target + window.location.pathname + window.location.search + window.location.hash);
      return;
    }

    // Azeka Health has its own canonical site (azekahealth.com). This Global /health
    // route is a non-canonical intro copy: it owns its own noindex + canonical tags
    // (see Health page Seo), so skip the global indexing/canonical handling here.
    if (pathname === "/health") return;

    const isIndexable = INDEXABLE_HOSTS.includes(host);
    const isAdmin = pathname.startsWith("/admin");
    upsertMetaRobots(!isIndexable || isAdmin ? "noindex, nofollow" : "index, follow");
    upsertCanonical(canonicalUrl(pathname));
  }, [pathname]);
  return null;
}
